<template>
  <vue-modal :name="modalId" :clickToClose="true" :draggable="true" :adaptive="true" @opened="loadData" :resizable="true" :width="747.5" :maxHeight="1550" :height="'auto'">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="dashboard-modal-card modal-body mx-auto d-flex">
          <sales-growth-university-slider @setTitle="setTitleBySliderNumber"/>
      </div> 
      <div class="modal-footer">
        <button type="button" class="btn btn-primary ml-4" @click="closeModal">Close</button>
      </div>
    </div>
  </vue-modal>
</template>
<script>
import DashboardCardMixins from "../mixins/DashboardCardMixins"
import SalesGrowthUniversitySlider from "../components/SalesGrowthUniversitySlider.vue";

export default {
  name: "SalesGrowthUniversityModal",
  mixins: [DashboardCardMixins],
  components: {SalesGrowthUniversitySlider},
  props: {},
  data() {
    return {
      title: "Welcome Aboard! Take a few minutes to learn how to analyze a company’s sales growth on our platform.",
      surveyGroupList: []
    };
  },
  methods: {
    setTitleBySliderNumber(sliderNumber) {
      if (sliderNumber === 1) {
        this.title = "Welcome Aboard! Take a few minutes to learn how to analyze a company’s sales growth on our platform.";
      } else if (sliderNumber === 2 ) {
        this.title = "Our weapons systems turns into your combat power.";
      } else if (sliderNumber === 3) {
        this.title = "We build a digital twin of any company’s customer set to assess and assist in their sales growth.";
      } else if (sliderNumber === 4) {
        this.title = "Rule 1: A company’s #1 competitor is customer expectations.";
      } else if (sliderNumber === 5) {
        this.title = "Rule 2: They may forget what you said, but they will never forget how you made them feel."
      } else if (sliderNumber === 6) {
        this.title = "Rule 3: Yesterday’s home runs don’t win today’s game. [Babe Ruth, Professional Baseball Player]";
      } else if (sliderNumber === 7) {
        this.title = "Rule 4: Pricing power is untapped growth, which customers seek through treasure hunting.";
      } else if (sliderNumber === 8) {
        this.title = "Rule 5: The precursor to an economic moat is a customer moat.";
      } else if (sliderNumber === 9) {
        this.title = "Rule 6: Be a rule-maker, not a rule-taker.";
      } else if (sliderNumber === 10) {
        this.title = "Rule 7: The fastest way to build a monopoly is to start a new game.";
      } else if (sliderNumber === 11 || sliderNumber === 2 ) {
        this.title = "Our weapons systems are now your combat power.";
      } else {
        this.title = "Need Title" ;
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  computed: {}
};
</script>
